// Scheduler is also multiple-choice esque (can prob compose these)
import Scheduler from './scheduler'

export default {
  13: Scheduler,
}
